import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pc0017',
    ecrans: ['00-2'],
    params: ['id']
});
